import { render, staticRenderFns } from "./QuickMenuComp.vue?vue&type=template&id=6c98b050&"
import script from "./QuickMenuComp.vue?vue&type=script&lang=js&"
export * from "./QuickMenuComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports